import {observable, action, computed} from 'mobx';
import { useStrict } from 'mobx';
import {transportStore} from './index';

useStrict(false);
export default class ScoreStore {
    constructor(menu = 100, total = 9900000){
        this.menu = menu;
        this.total = total;
        this.elevatorsName = 'РЕГИОНАЛЬНЫЙ ЭЛЕВАТОР'
    }

    @observable menu;
    @observable total;

    @action setElevatorsName(name){
        if(!name){this.elevatorsName="Elevator simulation #"+ Math.floor(Math.random()*10000);}else{
            this.elevatorsName = name;
        }
    };

    @action checkScore(){
        let fine = 1;
        transportStore.receptionTruck.forEach((item)=>{if(!item.disabled) fine -= item.groupQuantity*0.0035});
        transportStore.receptionTrain.forEach((item)=>{if(!item.disabled) fine -= item.groupQuantity*0.0035});
        if(this.menu + fine < 0){
            if(this.menu !== 0) {
                this.menu = 0;
            }
        }else{
            if(this.menu + fine >100){
                this.menu = 100
            }else{
                this.menu += fine;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/score.js